'use strict';

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2019/ToBoolean.js
// module id = 244
// module chunks = 0